export default __webpack_public_path__ + "static/media/icon_download.6825d571.svg";